import type { SuccessCelebration } from '../../utils/Chloromance/types';

type SuccessModalProps = {
  celebration: SuccessCelebration;
  onClose: () => void;
};

export function SuccessModal({ celebration, onClose }: SuccessModalProps) {
  return (
    <div className="success-backdrop" role="presentation" onMouseDown={onClose}>
      <section className="success-modal" role="dialog" aria-modal="true" aria-labelledby="success-title" onMouseDown={(event) => event.stopPropagation()}>
        <div className="confetti-field" aria-hidden="true">
          {Array.from({ length: 18 }, (_, index) => <span key={index} />)}
        </div>
        <p>Rooting For You!</p>
        <h2 id="success-title">{celebration.title}</h2>
        <span>{celebration.message}</span>
        <button type="button" onClick={onClose}>Back to Plants</button>
      </section>
    </div>
  );
}
